import {
// queryPhysicalStudentDetailInfo, //三、身心健康
newFileDownload as fileDownload
// queryTeachercomment, //9，教师评语接口
// addTeachercomments,
} from "@/api";
import ConfigTable from "@/components/Table/ConfigTable.vue";
// import { mapState } from "pinia";
import { API_HOST, Public_HOST } from "@/utils/request.js";
export default {
  name: "showTable",
  props: {
    studentData: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ConfigTable
  },
  // inject: ["schoolYears"],
  computed: {
    // ...mapState(["schoolYears", "userData"]),
    getApi() {
      return API_HOST();
    }
  },
  data() {
    return {
      disabled: false,
      grade: "",
      ca: [],
      listQuery: {},
      options: [],
      options2: [{
        value: "1",
        label: "第一学期"
      }, {
        value: "2",
        label: "第二学期"
      }],
      infoData: {
        physicalCategoryScoreInfoVoList: []
      },
      sius: {
        selection: false,
        // 头部数据
        tHead: [{
          label: "荣誉称号",
          field: "courseName1"
        }, {
          label: "获取日期",
          field: "setTime"
        }, {
          label: "颁发机构",
          field: "mid1"
        }],
        // 内容
        conBody: []
      },
      // 成绩信息
      tableGrade: {
        selection: false,
        // 头部数据
        tHead: [{
          label: "学科",
          field: "courseName1"
        }, {
          label: "期中考试",
          field: "mid1",
          width: 120
        }, {
          label: "期末考试",
          field: "fin1",
          width: 120
        }, {
          label: "学科",
          field: "courseName2"
        }, {
          label: "期中考试",
          field: "mid2",
          width: 120
        }, {
          label: "期末考试",
          field: "fin2",
          width: 120
        }],
        // 内容
        conBody: []
      },
      // 评价表格
      tableEvaluation: {
        selection: false,
        // 头部数据
        tHead: [{
          label: "类别",
          field: "categoryName",
          width: 200
        }, {
          // label: "项目",
          // type: "slot",
          // slotName: "project",
          type: "slot",
          label: "项目",
          field: "project",
          slotName: "project"
        }, {
          label: "分数",
          field: "score",
          width: 120
        }],
        // 内容
        conBody: []
      },
      // 社团数据
      tableSocieties: [],
      re: {
        selection: false,
        // 头部数据
        tHead: [{
          label: "获奖时间",
          field: "rewardDate"
        }, {
          label: "获奖名称",
          field: "rewardName"
        }, {
          label: "获奖等级",
          field: "rewardLevel"
        }, {
          label: "获奖单位",
          field: "rewardUnit"
        }],
        // 内容
        conBody: []
      },
      // 荣誉内容
      dataList: [],
      // 考勤统计
      recordCount: {},
      fullStatus: "",
      tec: [],
      // 教师评语
      num: -1,
      // 是否有暂存

      XYSP: [],
      //学业水平
      SXJK: [],
      //身心健康
      YSSY: [],
      //艺术素养
      XXSY: [],
      // 信息素养
      ZZNL: [] //组织能力
    };
  },
  created() {
    console.log(this.$pinia.state.value.user);
    this.listQuery = this.studentData;
    this.getFileDownload();
  },
  mounted() {
    // console.log(this.studentData);
    const schoolYeart = this.$pinia.state.value.user.userInfo.schoolYear;
    for (let j = 0; j < 5; j++) {
      const currentYear = String(schoolYeart - j);
      const nextYear = String(schoolYeart) - j + 1;
      const proName = currentYear + "-" + nextYear;
      this.options.push({
        label: proName,
        value: currentYear
      });
    }
  },
  methods: {
    // 学年改变，计算当前年级
    changeYear() {
      this.getStuInfo();
      this.getFileDownload();
      this.getQueryTeachercomment();
    },
    query() {
      this.getStuInfo();
      this.getFileDownload();
      this.getQueryTeachercomment();
    },
    async getFileDownload() {
      console.log(this.listQuery, "listQuery");
      const caValuesList = arr => {
        return arr.map(i => {
          i.classTitle = i.targetName;
          i.children = [];
          i.targetList.map(s => {
            return s.targetList.map((dd, index) => {
              let obj = {};
              if (index == 0) {
                obj = {
                  title: dd.targetName,
                  state: dd.evaluationResult,
                  itemTitle: s.targetName
                };
              } else {
                obj = {
                  title: dd.targetName,
                  state: dd.evaluationResult
                };
              }
              i.children.push(obj);
            });
          });
          return i;
        });
      };
      const res = await fileDownload(this.listQuery);
      // console.log(res);
      if (res.code === "success") {
        // console.log("6699", res.data);
        this.tableSocieties = res.data.club;
        this.fullStatus = res.data.vo.fullStatus; //考勤统计
        this.recordCount = res.data.vo; //学业水平
        this.tableGrade.conBody = res.data.co;
        this.ca = caValuesList(res.data.newCa.newEvaluationList);
        this.tableEvaluation.conBody = res.data.ca ?? [];
        this.tableEvaluation.conBody.push({
          categoryName: "总分",
          evaluationScoreInfoVoList: [],
          score: res.data.vo.caScore
        });
        this.re.conBody = res.data.re;
        //
        this.XYSP = res.data.vo.co; //csp改学业水平
        this.XYSP.forEach((item, index) => {
          if (this.grade > 2) {
            item.name = "2" + "." + (index + 2) + " " + item.name;
          } else {
            item.name = "2" + "." + (index + 1) + " " + item.name;
          }
        });
        this.SXJK = res.data.vo.ph ?? []; //身心健康
        this.SXJK.forEach((item, index) => {
          item.name = "3" + "." + (index + 2) + " " + item.name;
        });
        this.YSSY = res.data.vo.ar; //艺术素养
        this.XXSY = res.data.vo.it; //信息素养
        this.ZZNL = res.data.vo.os; //组织能力
      }
    },
    // 身体素质报告
    async getStuInfo() {
      // const res = await queryPhysicalStudentDetailInfo(this.listQuery);
      // if (res.code === "success") {
      //   this.infoData = res.data;
      // }
    },
    async getQueryTeachercomment() {
      // const res = await queryTeachercomment(this.listQuery);
      // if (res.code == "success") {
      //   // this.tec = res.data;
      //   this.num = res.data.findIndex((v) => {
      //     // Boolean("")v.waitCommit != ""
      //     return Boolean(v.waitCommit);
      //   });
      //   if (this.num == -1) {
      //     this.tec = res.data;
      //   } else {
      //     this.tec = res.data.map((v) => {
      //       v.commentText = v.waitCommit;
      //       return v;
      //     });
      //   }
      // }
    },
    // 暂存
    onTemporary() {
      this.$confirm("是否暂存当前评语?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.submit(true);
        // this.$message({
        //   type: 'success',
        //   message: '暂存成功!'
        // });
      }).catch(() => {});
    },
    // 提交
    async submit(type) {
      if (type) {
        this.tec.map(v => {
          v.waitCommit = v.commentText;
          delete v.commentText;
        });
      } else {
        this.tec.map(v => {
          v.waitCommit = null;
        });
      }
      let params = {};
      params = this.listQuery;
      params.teachercommentDetailAddVoList = this.tec;
      params.stuUserName = params.userName;
      // console.log(params);
      const res = await addTeachercomments(params);
      if (res.code == "success") {
        this.$message({
          message: res.msg,
          type: "success"
        });
        // this.dialogVisible2 = false;
        // this.$emit("upvisible", false);
        this.getQueryTeachercomment();
      }
    },
    // 导出
    async studentQualityBtn() {
      // const loading = this.$loading({
      //   lock: true,
      //   text: "正在导出文件数据，请勿刷新或关闭窗口！",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      // });

      // fetch(
      //   this.getApi +
      //     `/evaluationTargetRemote/newFileDownload?accessToken=${this.$pinia.state.value.user.token}&userName=${this.listQuery.userName}&schoolYear=${this.listQuery.schoolYear}&schoolTerm=${this.listQuery.schoolTerm}&schoolNum=${this.listQuery.schoolNum}&classCode${this.listQuery.classCode}`,
      //   {
      //     method: "get",
      //     headers: {
      //       "Content-Type": "application/x-www-form-urlencoded;",
      //       charset: "UTF-8",
      //       accessToken: this.$pinia.state.value.user.token,
      //     },
      //   }
      // ).then((res) => {
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = this.getApi + `/evaluationTargetRemote/newFileDownload?accessToken=${this.$pinia.state.value.user.token}&userName=${this.listQuery.userName}&schoolYear=${this.listQuery.schoolYear}&schoolTerm=${this.listQuery.schoolTerm}&schoolNum=${this.listQuery.schoolNum}&classCode=${this.listQuery.classCode}`;
      a.click();
      a = null;
      //   loading.close();
      // });
    }
  }
};